// Reactの機能とreact-dndライブラリからフックをインポートします。
import React from 'react';
import { useDrag, useDrop } from 'react-dnd';

// BuildItemコンポーネントは、リスト内の各コマンドアイテムのUIを担当し、
// ドラッグアンドドロップ機能を持つアイテムを表示します。
const BuildItem = ({ command, index, moveCommand, removeCommand, onValueChange }) => {
    // ドラッグアンドドロップで使用するアイテムのタイプを定義します。
    // これはドラッグされるアイテムがどのタイプに属しているかを特定するために使用されます。
    const ItemTypes = {
        COMMAND: 'command',
    };

    // ドラッグアンドドロップのための参照(ref)を設定します。このrefはDOM要素に直接関連付けられます。
    const ref = React.useRef(null);

    // useDropフックを使用してドロップ処理を設定します。
    const [, drop] = useDrop({
        accept: ItemTypes.COMMAND, // 受け入れるドラッグアイテムのタイプを指定します。
        hover(item, monitor) {
            if (!ref.current) {
                return;
            }
            // ドラッグされているアイテムのインデックスと現在ホバーしている場所のインデックスを取得します。
            const dragIndex = item.index;
            const hoverIndex = index;

            // ドラッグされているアイテムが現在ホバーしているアイテムと同じ場所にある場合は何もしません。
            if (dragIndex === hoverIndex) {
                return;
            }

            // ホバーしているアイテムの矩形とマウスの位置を取得し、ドラッグされたアイテムを移動するかどうかを判定します。
            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            // ドラッグアイテムとホバーアイテムの相対位置に基づいて、アイテムを移動させるかどうかの条件をチェックします。
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            // アイテムを移動させる関数を呼び出し、アイテムのインデックスを更新します。
            moveCommand(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
    });

    // useDragフックを使用してドラッグ処理を設定します。
    const [{ isDragging }, drag] = useDrag({
        type: ItemTypes.COMMAND, // ドラッグアイテムのタイプを指定します。
        item: { type: ItemTypes.COMMAND, id: command.command, index }, // ドラッグするデータを指定します。
        collect: (monitor) => ({
            isDragging: monitor.isDragging(), // ドラッグ中の状態を検出します。
        }),
    });

    // ドラッグ中のアイテムの透明度を設定します。ドラッグ中はアイテムを透明にします。
    const opacity = isDragging ? 0 : 1;
    // ドラッグとドロップの両方のrefを同じDOM要素に適用します。
    drag(drop(ref));

    // アイテムを表現するための行をレンダリングします。

    return (
        <tr ref={ref} style={{ opacity, cursor: 'move' }}>
            {command.fieldType !== 'hidden' ? (
                // inputのタイプがhiddenではない場合
                <>
                    <th width='30%'>{command.command}</th>
                    <td width='70%'>
                        <input
                            key={index}
                            type={command.fieldType}
                            value={command.value || ''}
                            onChange={(e) => onValueChange(index, e.target.value)}
                            readOnly={command.readonly}
                            placeholder={command.placeholder || ''}
                        />
                    </td>
                </>
            ) : (
                // inputのタイプがhiddenの場合、thとtdを結合
                <th colSpan="2" width='95%'>
                    {command.command}
                </th>
            )}
            <td width='5%'>
                <button onClick={() => removeCommand(index)}>×</button>
            </td>
        </tr>
    );
    
};

// コンポーネントをエクスポートします。
export default BuildItem;
